import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material";
import { Link } from "react-router-dom";

const CustomizedButton = styled(Button)`
  color: white;
`;

export default function BasicMenu({ buttonName, subMenuList }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <CustomizedButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="warning"
      >
        {buttonName}
      </CustomizedButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {subMenuList.map((item, index) => (
          <MenuItem key={index} onClick={handleClose}>
            <Link style={{textDecoration: 'none', color: 'inherit'}} to={item.link}>{item.name}</Link>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

